export default __webpack_public_path__ + "static/media/22.0ab7b777.png";